import { User } from '../utils/types';
import { graphQLEmptySplitApi } from './emptySplitApi';
import { updateAuthUser } from './features/authUserSlice';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../storeHook';
import { createGraphqlHeader } from '../utils/functions/headers';

type AuthUser = {
  actorDetails: {
    actorId: number;
    actorName: string;
    actorType: string;
  };
  username: string;
};

const transformAuthUser = (data: AuthUser) => {
  const role = data?.actorDetails?.actorType;
  const userId = data?.actorDetails?.actorId;
  const userName = data?.actorDetails?.actorName;
  const user_name = data?.username;

  const user: User = {
    role: role,
    userId: userId,
    userName: userName,
    user_name: user_name,
  };
  return user;
};

export const authUserService =
  graphQLEmptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
      ValidateUser: builder.query({
        query: (username) => ({
          url: '',
          method: 'POST',
          data: {
            query: `  
              query ValidateUser {
                ValidateUser(input: {
                  username: "${username}"  
                }) {
                  responseStatus {
                    status
                    statusReason
                    errorCode
                    reasons
                    errorMessages
                    internalErrorCode
                  }
                  username
                  name
                  actorDetails {
                    actorId
                    actorName
                    actorType
                  }
                  countryName
                }
              }
            `,
          },
          headers: createGraphqlHeader(),
        }),
        async onQueryStarted(
          args,
          { dispatch, queryFulfilled }
        ) {
          try {
            const { data } = await queryFulfilled;

            const transformedUser = transformAuthUser(
              data?.data?.ValidateUser
            );

            dispatch(updateAuthUser(transformedUser));
          } catch (error) {
            console.error('Error during query:', error);
          }
        },
      }),
    }),
  });

export const { useValidateUserQuery } = authUserService;
export const useRedefinedGetAuthUserQuery = () => {
  const queryReturn = useValidateUserQuery(null);
  const authUserFromRedux = useAppSelector(
    (state) => state.authUser
  );

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (queryReturn.isLoading) {
      setIsLoading(true);
    }
  }, [queryReturn.isLoading]);

  useEffect(() => {
    if (authUserFromRedux?.role) {
      setIsLoading(false);
    }
  }, [authUserFromRedux]);

  return {
    ...queryReturn,
    isLoading: isLoading || queryReturn.isLoading,
    data: authUserFromRedux,
  };
};
